import { render } from "./allocating.vue?vue&type=template&id=0eafeebc&scoped=true"
import script from "./allocating.vue?vue&type=script&lang=js"
export * from "./allocating.vue?vue&type=script&lang=js"

import "./allocating.vue?vue&type=style&index=0&id=0eafeebc&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\PC\\web-middleground\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eafeebc"]])

export default __exports__